import React from "react";
import harambot_text from "../assets/images/harambot_text.png";
import { Link } from "react-router-dom";

function Logo() {
  return (
    <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
      <img src="/android-chrome-512x512.png" alt="Harambot Icon" style={{ height: "40px", marginRight: "10px", borderRadius: "50%" }} />
      <img src={harambot_text} alt="Harambot Text" style={{ height: "30px", width: "auto" }} />
    </Link>
  );
}

export default Logo;